<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)"  size = "medium" color = "#fff" type = "square-jelly-box" [fullScreen] = "true"><p style="color: white" >please wait!.. </p></ngx-spinner>
<div id="myModal_4" class="profile_pop_2 profile_pop_up" role="dialog">
    <!-- <div class="modal-dialog"> -->
      <!-- Modal content-->
      <div class="abc">
        <div class="modal-content">
          <!-- <button type="button" style="outline: none;" (click)="dismiss()" class="close close_modal">
            <span aria-hidden="true">×</span> </button> -->
            <button type="button" class="close close_modal"  style="outline: none;" data-dismiss="modal" (click)="dismiss()"><span aria-hidden="true">×</span></button>

        <div class="modal-body">
                  <div class="row">
                  <div class="col-md-12">
                       <div class="home_a_text">
                              <div class="sction_new" *ngIf="isSearchOn == 0">
                                <div class="row">
                                  <div class="col-md-6" >
                                  <div class="search_done ">
                                  <h2 class="title text-center mb-5"> search </h2>
                                      <input type="" placeholder="Search Customer"  [(ngModel)]="user">
                                      <button (click)="saveNum()">Done</button>
                                  </div>
                                </div>
                                <div class="col-md-6" *ngIf="isSearchOn == 0">
                                  <div class="user_info">
                                  <table class="table table-bordered table-striped">
                                    <thead>
                                    <tr>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr *ngFor="let srch of searchedCust">
                                      <td> <a (click)="searchCu(srch.appUser.phone)">{{srch.appUser.phone}}</a></td>
                                      <td>{{srch.appUser.userName}}</td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                                </div>
                              </div>
                              <div *ngIf="isSearchOn == 1">
                                <div class="sction_new">
                                    <div class="search_done ">
                                    <h2 class="title text-center mb-5"> search </h2>
                                        <input type="" placeholder="Search Customer"  [(ngModel)]="user">
                                        <button (click)="saveNum()">Done</button>
                                    </div>
                                </div>
                                <div class="row">
                                <div class="col-md-4 vip_text text-center" *ngIf="memberType == 2">
                                  <h2 class="title text-center mb-5"> Member Id </h2>
                                    <h3 >{{phone}} </h3>
                                    </div>
                                    <div class="col-md-4 vvip_text text-center" *ngIf="memberType == 3">
                                      <h2 class="title text-center mb-5"> Member Id </h2>
                                        <h3 >{{phone}} </h3>
                                        </div>
                                        <div class="col-md-4 normal_text text-center" *ngIf="memberType == 1">
                                          <h2 class="title text-center mb-5"> Member Id </h2>
                                            <h3 >{{phone}} </h3>
                                            </div>
                                            <div class="col-md-8">
                                              <div class="textarea_side">
                                                <input type="" placeholder="Title" [(ngModel)]="selectedTitle">
                                                  <textarea placeholder="Write description here..." [(ngModel)]="selected"></textarea>
                                                <button (click)="sendTemp()" style="outline: none;"> Send </button> <button (click)="cancel()" style="outline: none;"> Cancel </button>

                                              </div>

                                              <!-- <div class="right_side">
                                                <div class="form-check form-check-inline" *ngFor="let tmp of template">
                                                   <input class="form-check-input" type="radio" (change)="changeTemp($event.target.value,	tmp)" [(ngModel)]="selcttmp" name="template" id="{{tmp.id}}" [value]="tmp.id">
                                                   <label class="form-check-label" for="inlineRadio1">{{tmp.title}}</label>
                                                 </div>
                                              </div> -->
                                              <div class="right_side">
                                                <a *ngFor="let tmp of template" (click)="changeTemp($event.target.value,tmp)"> {{tmp.title}} </a>
                                               </div>
                                            </div>
                                          </div>
                              <div class="sction_new ">
                                  <div class="search_done text-left ">
                                      <div class="search_details">
                                        <a (click)="editUser()" class="editt"> edit </a>
                        <h3>Customer Details:</h3>
                        <p> <span> Name :</span> {{name}}</p>
			  		<p> <span> Receipt Total :</span>{{recieptTotal}}</p>
			  		<p> <span> Phone Number :</span> {{phone}}</p>
			  		<p> <span> Preferred Salesman :</span>{{prefferedSale}}</p>
			  		<p> <span> Phone Model :</span>{{phoneModel}}</p>
			  		<p> <span>Recommended Members :</span>-</p>
			  		<p> <span> Birthday :</span>{{birthday*1000 | date:'longDate'}}</p>
			  		<!-- <p> <span> Member Points :</span>{{memberPOint}}</p> -->
			  		<p> <span> Postal Code :</span>{{postcode}}</p>
			  		<!-- <p> <span> Referral Points :</span> 0</p> -->
			  		<p> <span> Email :</span>{{email}}</p>
			  		<!-- <p> <span> Total Points :</span>{{recieptTotal}}</p> -->
            <p> <span> Member Since :</span>{{membersince}}</p>
            <!-- <p> <span> Claimed By :</span>{{claimedBy}}</p> -->
                  </div>
                                  </div>
                              </div>
                                     <div class="claim_side">
       <button style="outline: none;" *ngIf="claimed == 0 || adminId != claimedId" (click)='onClaim()'> Claim </button>
       <button style="outline: none;" *ngIf="claimed == 1 && adminId == claimedId" [ngClass]="{'active':claimed == 1}"> Claimed </button>
       </div>
                      <div class="sction_new ">
                        <div class="row">
                          <div class="col-md-4">
                      <div class="search_details mt-3">
                            <h3>Member Status</h3>
                            <a (click)="showUserModal(mymodal,1,'mem')" [ngClass]="{active:memberType == 1}">Member</a>
                            <a (click)="showUserModal(mymodal,2,'mem')" [ngClass]="{active:memberType == 2}">Vip</a>
                            <a (click)="showUserModal(mymodal,3,'mem')" [ngClass]="{active:memberType == 3}">Vvip</a>

                      </div>
                          </div>
                          <div class="col-md-8">
                            <div class="search_details_img">
                               <div class="form-check form-check-inline" *ngFor="let chr of character;index as i">
                              <input class="form-check-input" [checked]="chr.isAssigned" type="checkbox" id="{{chr.id}}" [value]="chr.id" (change)="onChange($event.target.checked, chr,i)">
                              <label class="form-check-label ser_form_chr" [ngClass]="{'active': chr.isSelected == 1}" for="{{chr.id}}">
                                <img loading="lazy" class="chr_img" [ngClass]="{'active': chr.isAssigned == true}" src="https://dev.vvip.com.sg:3011/{{chr.image}}" >
                                <p> {{chr.name}}</p></label>
                              </div>
                            </div>
                            </div>
                        </div>
                      </div>


                      <div class=" note_inner">
                      <div class=" row">

                      <div class="col-md-4 text-center mt-5">
                      <h2 class="title text-center" style="font-size:25px;">Add notes </h2>
                          <div class="promo">
                            <p>
                              <textarea placeholder="Write note here..." [(ngModel)]="notes"></textarea>
                           </p>
                           <p> <button (click)="addNote()"> ADD Note</button></p>
                          </div>
                      </div>
                      <div class="col-md-8 mt-5">
                      <div class="row ">
                        <div class="col-md-6 " *ngFor="let not of notesArr">
                          <div class="not_text">
                              <div class="media position-relative nots_image">
                                <img loading="lazy" [src]="imgUrl" (error) ="onImgError($event)" class="mr-3" alt="...">
                                <div class="media-body">
                                <a class="delet" (click)="deletNote(not.id)"> Delete </a>
                                <h5 class="">{{nameAdmin}}</h5>
                                <a>{{not.created*1000 | date:'medium'}}</a>
                                </div>
                              </div>
                              <p>{{not.description}}</p>
                          </div>
                        </div>
                      </div>
                      </div>
                  </div>
                  </div>
                  <div class="sction_new ">
				    <div class="search_details Promotion_Available  mt-3 redeem-vouchers ">
				  		<h3>Promotion Available</h3>
				  		<div class="row mt-4 pt-4">
                <!-------------------------------- BIRTHDAY PROMO DESIGN ----------------------------------->

                <div class="col-md-4">
                    <div class="gifts" >
                      <img loading="lazy" src="" (error)="onImgGift($event)">
                      <div class="bday_gft">
                        <p [ngClass]="bdayPromo == 1 && bdayPromoDate != 0 ? 'bday_fd' : ''">BIRTHDAY PROMO</p>
                        <p [ngClass]="bdayPromo == 1 && bdayPromoDate != 0 ? 'bday_fd bday_rdm' : 'bday_rdm'" *ngIf="bdayPromo != 0 && bdayPromoDate != 0">Date Redeemed:</p>
                        <p [ngClass]="bdayPromo == 1 && bdayPromoDate != 0 ? 'bday_fd bday_rdm' : 'bday_rdm'" *ngIf="bdayPromo != 0 && bdayPromoDate != 0">{{ bdayPromoDate * 1000 | date:'mediumDate' }}</p>
                        <button class="sms_btn" (click)="bday_promo_sms(bday_promo_sms_popup)"> 
                          <span *ngIf="bdayPromo == 1">NIL</span>
                          <span *ngIf="bdayPromo == 0">SMS</span>
                        </button>
                      </div>
                      
                    </div>
                </div>

                <!------------------------------------------------------------------------------------------>
		 		<div class="col-md-4" *ngFor="let avl of availablePromotions">
				    <div class="gifts new_gfts"  (click)="showUserModal(mymodal,1,avl.id)" >
              <img loading="lazy" src="https://dev.vvip.com.sg:3011/{{avl.image}}" (error)="onImgGift($event)">
              <p class="">{{avl.code}}</p>
                        <h3>${{avl.amount}}</h3>
				    </div>
				</div>
	</div>

				    </div>
		 	</div>
                      <div class="sction_new ">
                        <div class="search_details Promotion_Available mt-3 redeem-vouchers ">
                            <h3>Promotion Code</h3>
                            <div class="row mt-4 pt-4">
                   <div class="col-md-4" *ngFor="let prom of promotionsUsed">
                      <div class="gifts">
                        <img loading="lazy" src="https://dev.vvip.com.sg:3011/{{prom.image}}" (error)="onImgGift($event)">
                            <p class="">{{prom.code}}</p>
                            <a>{{prom.redeemedDate*1000 | date:'longDate'}}</a>
                            <h3>${{prom.amount}}</h3>
                            <!-- <h5>TEMPEREDGLASS <img loading="lazy" src="../../../../assets/images/copy.png"></h5> -->
                      </div>
                  </div>
      </div>

                      </div>
                      </div>
                      <div class="sction_new ">
                      <div class="search_details mt-3">
                            <h3>Add Receipt</h3>
                            <ul>

                                <li>
                                    <div class="up_lap">
                                        <button class="border-0" (click)="showReciept(reciept)">
                                            <img loading="lazy" src="../../../../assets/images/up.png">
                                        </button>
                                  </div>
                                </li>
                                <li>
                                     <div class="up_lap">
                                             <img loading="lazy" src="../../../../assets/images/lap.png">
                                    </div>
                                </li>
                            </ul>

                      </div>
                  </div>
                  <!-- <section class="Receipt">
        <div class="container">
           <h2 class="title text-center">Actions</h2>
          <div class="row mt-4 pt-4">

               <div class="col-md-12 mb-4">
                <div class="Sub_admins_on">
                  <div class="Sub_admins">
                    <div class="media position-relative sub_image" *ngFor="let acts of actionCust">
						<img loading="lazy" src="https://dev.vvip.com.sg:3011/{{acts.user.image}}" class="mr-3" alt="..." (error)="onImgError($event)">
						<div class="media-body">
						  <h5 class="">{{acts.user.userName}}  <br/> <span> {{acts.created*1000 | date :'fullDate'}}</span></h5>
						  <p>{{acts.action}}</p>
						</div>
					  </div>
                  </div>
                </div>
              </div>

        </div>
      </div>
    </section> -->
              <div class="row_fit">
              <h2 class="title text-center mt-3"> Receipts </h2>
                              <div class="row mt-4 pt-4">
                   <div class="col-md-6" *ngFor="let rcp of reciepts">
                      <div class="Receipt_details">
                        <a (click)="showRcpt(imageReciept,rcp.image)">
                          <img loading="lazy" src="https://dev.vvip.com.sg:3011/{{rcp.image}}" (error)="onErr($event)">
                        </a>
                            <p class="">Receipt Value : <b>{{rcp.amount}}</b></p>
                            <p>Date : <b>{{rcp.createdAt*1000 | date:'longDate'}}</b>  </p>
                            <p *ngIf="rcp.detail !== 'undefined'">Detail :{{rcp.detail}}</p>
						  <p *ngIf="rcp.detail == 'undefined'">Detail :--</p>

                      </div>
                  </div>
      </div>
      </div>
      <div class="sction_new ">
        <div class="search_details Promotion_Available mt-3 redeem-vouchers ">
            <h2 class="title text-center mt-3">Actions</h2>
            <div class="col-md-12 mb-4">
              <div class="Sub_admins">
                <div class="media position-relative sub_image" *ngFor="let acts of actionCust">
        <img loading="lazy" src="https://dev.vvip.com.sg:3011/{{acts.user.image}}" class="mr-3" alt="..." (error)="onImgError($event)">
        <div class="media-body">
          <h5 class="">{{acts.user.userName}}  <br/> <span> {{acts.created*1000 | date :'fullDate'}}</span></h5>
          <p>{{acts.action}}</p>
        </div>
        </div>
              </div>
          </div>

      </div>
      </div>


                        </div>
                    </div>
                  </div>
              </div>
        </div>
      </div>
    </div>

  </div>



  <ng-template #imageReciept let-modal>
		<div id="Re_modal" class="login_me" role="dialog">
			<!-- <div class="modal-dialog"> -->
			  <!-- Modal content-->
			  <div class="modal-content">
				<button type="button" style="outline: none;" (click)="modal.dismiss('Cross click')" class="close close_modal" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">×</span> </button>
				<div class="modal-header">
				  <h4 class="modal-title">Receipt </h4>
				</div>
				<div class="modal-body">
					   <img loading="lazy" [src]="rcptImg" (error)="onImgError($event)" style="max-width: 50%;">
				</div>
			  </div>
			<!-- </div> -->
		  </div>
	  </ng-template>

  <ng-template #mymodal let-modal>
    <div id="member_status" class="login_me" role="dialog">
        <!-- <div class="modal-dialog"> -->
          <!-- Modal content-->
          <div class="modal-content">
             <button type="button" style="outline: none;" id="closeBtn" (click)="modal.dismiss('Cross click')" class="close close_modal" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span> </button>
            <div class="modal-header">
              <h5 class="modal_title_2"> {{modalHeading}}</h5>

            </div>
            <div class="modal-body">
              <div class=" admin_member">
                      <img loading="lazy" src="../../../../assets/images/logo.png">
                    <p>Admin Password</p>

              </div>
              <form class="member_status_form">
                <div class="row">
                   <div class="col-md-7 mx-auto">
                     <!-- <div class="form-row">
                        <div class="form-group col-md-3">
                           <input type="text" formControlName="p1" name=""  class="form-control" id="email" placeholder="_" autocomplete="off" >
                           <ng-container *ngIf="submitted && pIn.p1.errors">
                             <p class="error-message" *ngIf=" pIn.p1.errors.required">
                                 Please enter password
                             </p>
                             <p class="error-message" *ngIf=" pIn.p1.errors.minlength">
                                 Password must be of 1 digit
                             </p>
                             <p class="error-message" *ngIf=" pIn.p1.errors.maxlength">
                                Password must be of 1 digit
                             </p>
                             <p class="error-message" *ngIf=" pIn.p1.errors.pattern">
                                 Password must only be digits
                             </p>
                         </ng-container>
                        </div>
                        <div class="form-group col-md-3">
                           <input type="text" formControlName="p2" name="" class="form-control" id="email" placeholder="_" autocomplete="off" >
                           <ng-container *ngIf="submitted && pIn.p2.errors">
                             <p class="error-message" *ngIf=" pIn.p2.errors.required">
                                 Please enter password
                             </p>
                             <p class="error-message" *ngIf=" pIn.p2.errors.minlength">
                                 Password must be of 1 digit
                             </p>
                             <p class="error-message" *ngIf=" pIn.p2.errors.maxlength">
                                 Password must be of 1 digit
                             </p>
                             <p class="error-message" *ngIf=" pIn.p2.errors.pattern">
                                 Password must only be digits
                             </p>
                         </ng-container>
                        </div>
                        <div class="form-group col-md-3">
                           <input type="text" formControlName="p3" name=""  class="form-control" id="email" placeholder="_" autocomplete="off" >
                           <ng-container *ngIf="submitted && pIn.p3.errors">
                             <p class="error-message" *ngIf=" pIn.p3.errors.required">
                                 Please enter password
                             </p>
                             <p class="error-message" *ngIf=" pIn.p3.errors.minlength">
                                 Password must be of 1 digit
                             </p>
                             <p class="error-message" *ngIf=" pIn.p3.errors.maxlength">
                                 Password must be of 1 digit
                             </p>
                             <p class="error-message" *ngIf=" pIn.p3.errors.pattern">
                                 Password must only be digits
                             </p>
                         </ng-container>
                        </div>
                        <div class="form-group col-md-3">
                           <input type="text" formControlName="p4" name="" class="form-control" id="email" placeholder="_" autocomplete="off" >
                           <ng-container *ngIf="submitted && pIn.p4.errors">
                             <p class="error-message" *ngIf=" pIn.p4.errors.required">
                                 Please enter password
                             </p>
                             <p class="error-message" *ngIf=" pIn.p4.errors.minlength">
                                 Password must be of 1 digit
                             </p>
                             <p class="error-message" *ngIf=" pIn.p4.errors.maxlength">
                                 Password must be of 1 digit
                             </p>
                             <p class="error-message" *ngIf=" pIn.p4.errors.pattern">
                                 Password must only be digits
                             </p>
                         </ng-container>
                        </div>

                     </div> -->
                     <ng-container *ngIf="supAdmin == 0">
                      <ng-otp-input #ngOtpInput  (onInputChange)="onOtpChange($event)" [config]="{length:4,allowNumbersOnly:true,disableAutoFocus:true
                      }"></ng-otp-input>
                    </ng-container>
                    <ng-container *ngIf="supAdmin == 1">
                      <ng-otp-input #ngOtpInput  (onInputChange)="onOtpChange($event)" [config]="{length:1,allowNumbersOnly:true,disableAutoFocus:true
                      }"></ng-otp-input>
                    </ng-container>
                     </div>

                     <div class="col-md-12">
                        <a class="sign_in" (click)="onSubmit()"> Enter </a>
                    </div>
                   </div>
               </form>
            </div>
          </div>
        <!-- </div> -->
      </div>

  </ng-template>
  <ng-template #reciept let-modal>
    <div id="Receipt_modal" class="login_me" role="dialog">
        <!-- <div class="modal-dialog"> -->
          <!-- Modal content-->
          <div class="modal-content">
            <button type="button" style="outline: none;" (click)="modal.dismiss('Cross click')" class="close close_modal" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span> </button>
            <div class="modal-header">
              <h4 class="modal-title"> Save Receipt </h4>
            </div>
            <div class="modal-body">
                  <form class=" recipt_form">
                      <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <img loading="lazy" [src]="recieptImage">
                      <input type="file" class="form-control rec_img_up" nbInput fullWidth #file capture="camera" accept="image/*" id="cameraInput" name="cameraInput" (change)="onFileSelected(file.files)">
                      <!-- <button type="button" (click)="onUpload()">Upload File</button> -->
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <input type="text" [(ngModel)]="keydetail" [ngModelOptions]="{standalone: true}"  class="form-control" id="email" placeholder="add detail">
                    </div>
                    </div>

                      <div class="col-md-12">
                    <div class="form-group">
                      <input type="text" [(ngModel)]="keyValue" [ngModelOptions]="{standalone: true}"  class="form-control" id="email" placeholder="add key reciept value">
                    </div>
                    </div>
                    <div class="col-md-12">
                    <div class="form-group">
                      <input type="text" class="form-control" id="pwd"  readonly value="{{phone}}">
                    </div>
                    </div>

                    <div class="col-md-12">
                        <a class="sign_in" (click)="onUpload()"> Save </a>
                   </div>
                   </div>
                  </form>
            </div>
          </div>
        <!-- </div> -->
      </div>
  </ng-template>

  <ng-template #bday_promo_sms_popup let-modal>
    <div id="bday_promo_sms_popup" class="login_me" role="dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <button type="button" style="outline: none;" class="close close_modal" (click)="modal.dismiss('Cross click')"
          data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span> </button>
        <div class="modal-header">
          <h5 class="modal_title_2">
            BIRTHDAY PROMOTION
          </h5>
  
        </div>
        <div class="modal-body">
          <div class=" admin_member">
            <img loading="lazy" src="../../../../assets/images/logo.png">
            <p>ENTER OTP</p>
  
          </div>
          <form class="member_status_form">
            <div class="row">
              <div class="col-md-7 mx-auto">
                <div class="form-row">
  
                </div>
                <ng-container>
                  <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" [config]="{length:4,allowNumbersOnly:true,disableAutoFocus:true
                          }"></ng-otp-input>
                </ng-container>
              </div>
  
              <div class="col-md-12">
                <a class="sign_in" (click)="verify_bday_sms()"> Submit </a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </ng-template>